import { Center, CenterProps, Spinner } from "@chakra-ui/react";

export default function LoadingSpinner(props: CenterProps) {
  return (
    <Center {...props}>
      <Spinner size="xl" color="gray.500" thickness="3px" />
    </Center>
  );
}
